import { Route } from '@angular/router';
import { FirstLoginComponent } from './first-login.component';
import { ChangePasswordComponent } from '../change-password/change-password.component';
import { EditAccountInfoComponent } from '../edit-account-info/edit-account-info.component';
import { VerifyOtpComponent } from '../verify-otp/verify-otp.component';

export const firstLoginRoute: Route = {
    path: 'primoAccesso',
    // component: FirstLoginComponent,
    component: ChangePasswordComponent,
    data: {
        pageTitle: 'pagetitles.forcechangepassword',
        isFirstLogin: true
    }
};

export const firstLoginChangeInfoRoute: Route = {
    path: 'primoAccessoModificaProfilo',
    component: EditAccountInfoComponent,
    data: {
        pageTitle: 'pagetitles.editaccountinfo',
        isFirstLogin: true
    }
};

export const firstLoginVerifyOtpRoute: Route = {
    path: 'primoAccessoVerificaOTP',
    component: VerifyOtpComponent,
    data: {
        pageTitle: 'pagetitles.verifyotp',
        isFirstLogin: true
    }
};
